export const DATA_STEPS = {
  EMPTY: "empty",
  LOADING: "running",
  ERROR: "failed",
  SUCCESS: "success",
  VALIDATE_CODE: "validateCode",
  PENDING: "pending",
};
